// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function CaretsOut(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "CaretsOut" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 19.5V4.5L22 12L14 19.5Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 4.5V19.5L2 12L10 4.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=CaretsOut.js.map